import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const ModulesPageHeader = styled.header`
  margin: 32px 0 24px;

  h2 {
    margin: 0;
    color: #163247;
    font-family: 'Public Sans', sans-serif;
    font-size: 26px;
    font-weight: 800;
    line-height: 1.2;
  }

  p {
    margin: 8px 0 0;
    color: #63788d;
    font-family: 'Public Sans', sans-serif;
    font-size: 1rem;
    line-height: 1.45;
  }
`

export const ModuleSection = styled.section`
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #d7e0ea;

  &:first-of-type {
    margin-top: 0;
    padding-top: 0;
    border-top: 0;
  }
`

export const SectionTitle = styled.h3`
  margin: 0 0 14px;
  color: #163247;
  font-family: 'Public Sans', sans-serif;
  font-size: 1.05rem;
  font-weight: 800;
  line-height: 1.3;
`

export const ModulesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 340px));
  gap: 16px;
  width: 100%;
  max-width: 1120px;
`

export const ModuleCardLink = styled(Link)`
  display: block;
  color: inherit;
  text-decoration: none;
`

export const Card = styled.article`
  display: flex;
  align-items: stretch;
  min-height: 104px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e0e8f0;
  border-radius: 14px;
  box-shadow: 0 8px 18px rgba(31, 52, 77, 0.07);
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;

  &:hover {
    border-color: #b8cee0;
    box-shadow: 0 12px 24px rgba(31, 52, 77, 0.12);
    transform: translateY(-2px);
  }
`

export const CardIconSection = styled.div`
  display: flex;
  flex: 0 0 80px;
  align-items: center;
  justify-content: center;
  background: #e8f2f8;
`

export const CardDescriptionSection = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
  gap: 10px;
  padding: 16px;
`

export const CardTitle = styled.div`
  overflow: hidden;
  color: #163247;
  font-family: 'Public Sans', sans-serif;
  font-size: 1.05rem;
  font-weight: 800;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ModuleAction = styled.span`
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  box-sizing: border-box;
  padding: 0 12px;
  border: 1px solid #b7cbe0;
  border-radius: 999px;
  color: #2d749c;
  font-family: 'Public Sans', sans-serif;
  font-size: 0.84rem;
  font-weight: 700;
  line-height: 1;
`

export const ModuleKpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 300px));
  gap: 14px;
  width: 100%;
  max-width: 1120px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`

export const ModuleKpiLink = styled(Link)`
  display: block;
  color: inherit;
  text-decoration: none;
`

export const ModuleKpi = styled.div`
  display: flex;
  align-items: center;
  min-height: 86px;
  box-sizing: border-box;
  padding: 14px;
  border: 1px solid #e0e8f0;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 7px 16px rgba(31, 52, 77, 0.07);
  cursor: pointer;
  transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;

  &:hover {
    border-color: #b8cee0;
    box-shadow: 0 11px 22px rgba(31, 52, 77, 0.12);
    transform: translateY(-2px);
  }
`

export const ModuleKpiIcon = styled.span<{ tone?: 'pink' | 'blue' | 'violet' | 'amber' | 'green' }>`
  display: inline-flex;
  flex: 0 0 42px;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: ${({ tone = 'blue' }) =>
    ({
      pink: '#fbe8f3',
      blue: '#e8f2f8',
      violet: '#f0ebf8',
      amber: '#fff5e3',
      green: '#e8f8f1',
    }[tone])};
  color: ${({ tone = 'blue' }) =>
    ({
      pink: '#c6016b',
      blue: '#2d749c',
      violet: '#7c63b8',
      amber: '#d99000',
      green: '#27ad76',
    }[tone])};
`

export const ModuleKpiContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  margin-left: 12px;
`

export const ModuleKpiTitle = styled.span`
  overflow: hidden;
  color: #163247;
  font-family: 'Public Sans', sans-serif;
  font-size: 0.98rem;
  font-weight: 800;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ModuleKpiAction = styled.span`
  margin-top: 4px;
  color: #63788d;
  font-family: 'Public Sans', sans-serif;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.2;
`

export const Icon = styled.img`
  width: 56px;
  height: 56px;
  object-fit: contain;
`

export const UploadSizeRecomended = styled.p`
  width: 174px;
  color: #797a7c;
  font-weight: 100;
  font-size: 16px;
`
